import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectIsCurrentGeoInCPD } from 'shared/selectors/cpd';
import { selectIsUserInCPD } from 'shared/selectors/user';

import { ICPDBannerData } from '../types';
import { useApplicationContext } from 'shared/utils/applicationContext';

export function useGetCPDSettings() {
  const { config } = useApplicationContext();
  const CPDBannerData = config.get<ICPDBannerData>('agents-directory-frontend.CPDBannerData');
  const isUserInCPD = useSelector(selectIsUserInCPD);
  const isCurrentGeoInCPD = useSelector(selectIsCurrentGeoInCPD);

  const isBannerVisible = isUserInCPD;

  return React.useMemo(
    () => ({ isBannerVisible, isCurrentGeoInCPD, CPDBannerData }),
    [isBannerVisible, isCurrentGeoInCPD, CPDBannerData],
  );
}
